<template>
	<v-dialog width="600px" persistent v-model="showDialog">
		<v-card class="details-card">
			<v-card-text>
				<div
					class="list-item"
					v-for="(value, key) in filteredRetailerDetails"
					:key="key"
				>
					<div class="pr-4 caption blue-grey--text text--lighten-1">
						{{ keyToNameMap[key] ? keyToNameMap[key] : key }}
					</div>
					<div
						class="align-right caption blue-grey--text text--darken-3"
					>
						{{ value }}
					</div>
				</div>
			</v-card-text>
			<div class="d-flex">
				<v-btn
					class="btn white--text"
					@click="closeModal"
					:color="themeInputColor"
					>Close</v-btn
				>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	name: "RetailerDetails",
	props: ["retailerDetails", "model", "themeInputColor"],
	data() {
		return {
			showDialog: true,
			keyToNameMap: {
				id: "User ID",
				name: "Name",
				phoneNo: "Phone Number",
				walletBalance: "Wallet Balance",
				totalInputAmount: "Total Input Amount",
				language: "Language",
				totalCommissionEarned: "Commission Earned",
				totalCreditsTransfer: "Total Credits Transfer",
				retailerName: "Name"
			},
			hideKeys: ["userType", "userId", "distributorId"]
		};
	},
	methods: {
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		}
	},
	computed: {
		filteredRetailerDetails: function() {
			const newObj = {};
			Object.keys(this.retailerDetails).forEach(key => {
				if (this.hideKeys.indexOf(key) == -1) {
					newObj[key] = this.retailerDetails[key];
				}
			});
			return newObj;
		}
	}
};
</script>
<style scoped>
.list-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 5px;
	border-bottom: 1px solid rgba(204, 204, 204, 0.418);
}
.details-card {
	border-radius: 16px;
	padding: 1em;
}
.align-right {
	display: flex;
	justify-content: right;
	direction: rtl;
	overflow-wrap: anywhere;
}
</style>
